import { Component, OnInit, Input } from '@angular/core';
import { SetService } from 'ngx-block-core';
import { FormGroup } from '@angular/forms';
import { FormControlService } from "ngx-block-core";
import { selectSize, dataMode, disabledHours, disabledMinutes } from "../../../data/data";
import {  getDayOfYear ,getDate,getTime} from 'date-fns';
import { filter, distinctUntilChanged, debounceTime } from 'rxjs/operators';
@Component({
  selector: 'app-sucu04-weiget0040002',
  templateUrl: './sucu04-weiget0040002.component.html',
})
export class Sucu04Weiget0040002Component implements OnInit {

  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() form: FormGroup;
  @Input() nzFormGroupData;
  @Input() nzLayout = 'horizontal'
  time: Date | null = null;
  @Input() sets = {
    blockCode:"sucublock24",
    blockId: "",
    blockName: "日期控件",
    layoutId: "",
    blockType: 'formBlock',
    blockChildType: '',
    versionCode: 4,
    attributes: ['form', 'nzFormGroupData', 'nzLayout'],
    styles: {
      nzReadOnly: false,
      nzAllowEmpty: true,
      nzFormat: "HH:mm:ss",
      nzPlaceHolder: "请选择时间",

      nzLayout: {
        nzLayout1: 0,
        nzLayout2: 8,
        nzLayout3: 0,
        nzLayout4: 16,
        nzAlign: 'left',
        nzMarginBottom:3,
        nzLineHeight:1.4,
        nzFontSize:12
      },
      nzRequired: false,
      nzHasFeedback: true,
      nzNoSee:false
    },
    datas: {
      nzSearchDataType: "date",
      nzSearchType: "=",
      nzDisabledTime: {
        nzDisabledHours: [],
        nzDisabledMinutes: [],
        nzDisabledSeconds: [],
      },
    }
  };
  setData = []
  constructor(
    public setService: SetService,
    private formControlService: FormControlService
  ) { }
  ngOnInit() {
    this.baseInit();

    this.autoUpdate();
    console.log("valueChanges")
    this.form.get(this.nzFormGroupData.nzKey).valueChanges.pipe(
      //同valueChanges，不写也可
      distinctUntilChanged(),
      //防抖时间，单位毫秒
      debounceTime(600),
    ).subscribe((val) => {
      
      if(typeof this.form.get(this.nzFormGroupData.nzKey).value!="object"){
        console.log("change",this.form.get(this.nzFormGroupData.nzKey).value);
        if(this.form.get(this.nzFormGroupData.nzKey).value==""){
          this.time=null;
        }
        else
          this.time=new Date(getTime(this.form.get(this.nzFormGroupData.nzKey).value))  ;

      }
      

    });
    console.log("getDate",getDate(this.form.get(this.nzFormGroupData.nzKey).value) );
  }

  autoUpdate() {

    //v3,升级自定义表单参数
    if (this.sets.versionCode < 3) {

        this.sets.blockCode = "sucublock24";

        this.sets.versionCode = 3;
    }
    //v4,升级自定义表单参数
    if (this.sets.versionCode < 4) {
      if (typeof this.sets.styles.nzNoSee == "undefined") 
      this.sets.styles.nzNoSee=false;
      this.sets.versionCode = 4;
    }

}
  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormDataSource' },
              {
                name: 'nzFormSearchType',
                inputs: {
                  dateFormat: true, nzData: [ { value: '=', label: '精确匹配(=)' }]
                }
              }
            ]
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "可清除 : ", nzKeys: ['styles', 'nzAllowEmpty'], }
              },
              {
                name: 'switch',
                inputs: { nzText: "只读 : ", nzKeys: ['styles', 'nzReadOnly'] }
              },
              {
                name: 'input', 
                inputs: { nzText: "格式 : ", nzKeys: ['styles', 'nzFormat'] }
              },
              {
                name: 'input', 
                inputs: { nzText: "提示文字 : ", nzKeys: ['styles', 'nzPlaceHolder'] }
              },
              {
                name: 'nzLayout'
              },
              {
                name: 'select',
                inputs: { nzText: "禁用小时 : ", nzKeys: ['datas', 'nzDisabledTime', 'nzDisabledHours'], nzData: disabledHours, nzMode: 'multiple', nzDataKeys: ['null'] }
              },
              {
                name: 'select',
                inputs: { nzText: "禁用分钟 : ", nzKeys: ['datas', 'nzDisabledTime', 'nzDisabledMinutes'], nzData: disabledMinutes, nzMode: 'multiple', nzDataKeys: ['null'] }
              },
              {
                name: 'select',
                inputs: { nzText: "禁用秒 : ", nzKeys: ['datas', 'nzDisabledTime', 'nzDisabledSeconds'], nzData: disabledMinutes, nzMode: 'multiple', nzDataKeys: ['null'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "表单忽视 : ", nzKeys: ['styles', 'nzNoSee'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.nzFormGroupData['nzSearchDataType'] = "noSee";
                    else
                      this.nzFormGroupData['nzSearchDataType'] = "date";
                  }
                }
              },
            ]
          },
        
        ]
      },
      {
        tabName: '表单',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormSet' },
            ]
          }
        ]
      }
    ]
  }
  baseInit() {

    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.nzFormGroupData['nzSearchDataType'] = "date";
        if (this.sets.styles.nzNoSee == true)
          this.nzFormGroupData['nzSearchDataType'] = "noSee";
        if (this.nzFormGroupData['nzSearchType'] == 'null')
          this.nzFormGroupData['nzSearchType'] = "=";
          this.setDataInit();
          if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
              this.setService.setDatas[this.blockid] = this.setData;
          }
          
        this.pzListening()
      }
      else {//静态
        if(typeof this.sets=="string")
        this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
      }
    }
  }
  ngOnDestroy() {
    if (!this.static) this.setService.deleteEvent(this.blockid, 'pz')
  }
  click12(){
    this.time=new Date(getTime(this.form.get(this.nzFormGroupData.nzKey).value))  ;
    console.log("typeof",typeof this.form.get(this.nzFormGroupData.nzKey).value);
    console.log("getDate",getDate(this.form.get(this.nzFormGroupData.nzKey).value) );
  }
  pzListening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid, 'pz');
      this.setService.pzEvents[this.blockid].subscribe(data => {
        switch (data['type']) {
          case 'changeFormValid':
            this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
            break;
          case 'savadefault':
            this.nzFormGroupData['nzValue']['nzValue'] =this.form.get(this.nzFormGroupData['nzKey']).value;
            break; 

          default:
            break;
        }
      }
      )
    }, 100);

  }
  // disabledHours(sets): number[] {
  //   console.log('sets',JSON.stringify(sets))
  //   return sets.datas.nzDisabledTime.nzDisabledHours;
  // }

  // disabledMinutes(hour: number,sets): number[] {
  //   console.log('sets2',JSON.stringify(sets))
  //  return  sets.datas.nzDisabledTime.nzDisabledMinutes;
  // }

  // disabledSeconds(hour: number, minute: number,sets): number[] {
  //   console.log('sets3',JSON.stringify(sets))
  //   return sets.datas.nzDisabledTime.nzDisabledSeconds;
  // }

}
